// Colorado Springs neighborhood + ZIP coverage.
// Used for on-page content and LocalBusiness areaServed schema.

export const CS_NEIGHBORHOODS = [
  "Briargate",
  "Powers Corridor",
  "Northgate",
  "Black Forest",
  "Falcon",
  "Old Colorado City",
  "Downtown",
  "Broadmoor",
  "Skyway",
  "Rockrimmon",
  "Pleasant Valley",
  "Cheyenne Mountain",
  "Stetson Hills",
  "Cordera",
  "Wolf Ranch",
  "Flying Horse",
  "Gleneagle",
  "Peregrine",
  "Mountain Shadows",
  "Ivywild",
  "Patty Jewett",
  "Knob Hill",
  "Security-Widefield",
  "Fountain Valley",
  "Cimarron Hills",
] as const;

export const CS_ZIPS = [
  "80132", "80133", "80817", "80831", "80863",
  "80901", "80903", "80904", "80905", "80906",
  "80907", "80908", "80909", "80910", "80911",
  "80915", "80916", "80917", "80918", "80919",
  "80920", "80921", "80922", "80923", "80924",
  "80925", "80926", "80927", "80928", "80929",
  "80938", "80939", "80951",
] as const;

// Extended 30-mile service radius around our Woodmen Rd office.
// These are real cities/towns we actively serve from Colorado Springs.
export const CS_EXTENDED_AREAS = [
  "Monument",
  "Tri-Lakes",
  "Palmer Lake",
  "Fountain",
  "Security-Widefield",
  "Manitou Springs",
  "Peyton",
  "Calhan",
  "Ellicott",
  "Percheron",
  "Woodland Park",
  "Cañon City",
  "Castle Rock",
  "Pueblo",
  "Limon",
] as const;

export function buildCSAreaServed() {
  return [
    { "@type": "City", name: "Colorado Springs" },
    ...CS_NEIGHBORHOODS.map((name) => ({ "@type": "Place", name })),
    ...CS_EXTENDED_AREAS.map((name) => ({ "@type": "City", name })),
    ...CS_ZIPS.map((postalCode) => ({
      "@type": "PostalCodeArea",
      postalCode,
      addressCountry: "US",
    })),
  ];
}
